import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import type { CanvasToolbarOrientation } from "./CanvasToolbarShell";
import { canvasToolbarGroupVariants } from "./canvasToolbarStyles";

interface CanvasToolbarGroupProps extends ComponentPropsWithoutRef<"div"> {
  well?: boolean;
  orientation?: CanvasToolbarOrientation;
}

export function CanvasToolbarGroup({
  well = false,
  orientation = "horizontal",
  className,
  children,
  ...rest
}: CanvasToolbarGroupProps) {
  return (
    <div
      className={cn(
        canvasToolbarGroupVariants({ well, orientation }),
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
